module.exports = __webpack_public_path__ + "img/music-player-fill.c65bc093.svg";